module.exports = "/_next/static/images/4eba717d16aa6c2e317e33d42d43dc05-slide-1-small.png";